const STORAGE_KEY = "mock_vendors_v1";

const clone = (value) => JSON.parse(JSON.stringify(value));

const normalizeBool = (val) => val === true || val === 1 || val === "1";

function loadVendors() {
  const raw = sessionStorage.getItem(STORAGE_KEY);
  if (!raw) {
    return [];
  }

  try {
    const parsed = JSON.parse(raw);
    if (Array.isArray(parsed)) return parsed;
  } catch (error) {
    // fall through and reset
  }

  return [];
}

function saveVendors(vendors) {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(vendors));
}

function createResponse(data, status = 200) {
  return Promise.resolve({
    status,
    data,
  });
}

function nextId(vendors) {
  const maxId = vendors.reduce((max, v) => {
    const id = Number(v.vendor_id) || 0;
    return id > max ? id : max;
  }, 0);
  return maxId + 1;
}

function sortRows(rows, sortBy = "company^asc") {
  const [field, direction] = String(sortBy || "company^asc").split("^");
  const multiplier = String(direction || "asc").toLowerCase() === "desc" ? -1 : 1;

  return rows.sort((a, b) => {
    const av = (a[field] || "").toString().toLowerCase();
    const bv = (b[field] || "").toString().toLowerCase();
    if (av < bv) return -1 * multiplier;
    if (av > bv) return 1 * multiplier;
    return 0;
  });
}

function withListFields(row) {
  return {
    ...row,
    country_name: row.country_name || row.country || "",
    deleted: normalizeBool(row.deleted),
  };
}

export const getAllVendor = async (params = {}) => {
  const {
    search = "",
    country = "",
    deleted = false,
    limit = 20,
    page = 1,
    sort_by = "company^asc",
  } = params;

  const query = String(search).trim().toLowerCase();
  const countryQuery = String(country || "").trim().toLowerCase();
  const includeDeleted = normalizeBool(deleted);

  let rows = loadVendors().map(withListFields).filter((row) => {
    const deletedOk = includeDeleted ? true : !normalizeBool(row.deleted);
    if (!deletedOk) return false;

    const searchText = [row.company, row.name, row.fname, row.email]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();

    const searchOk = query ? searchText.includes(query) : true;
    const countryText = String(row.country || row.country_name || "").toLowerCase();
    const countryOk = countryQuery ? countryText.includes(countryQuery) : true;

    return searchOk && countryOk;
  });

  rows = sortRows(rows, sort_by);

  const perPage = Number(limit) || 20;
  const currentPage = Number(page) || 1;
  const start = (currentPage - 1) * perPage;
  const pagedRows = rows.slice(start, start + perPage);

  return createResponse({
    status: true,
    message: "Success",
    data: {
      data: pagedRows,
      pagination: {
        total: rows.length,
        page: currentPage,
        limit: perPage,
      },
    },
  });
};

export const getVendorByID = async (id) => {
  const vendors = loadVendors();
  const vendor = vendors.find((v) => Number(v.vendor_id) === Number(id));

  if (!vendor) {
    return createResponse(
      {
        status: false,
        message: "Contact not found",
        data: null,
      },
      404
    );
  }

  return createResponse({
    status: true,
    message: "Success",
    data: {
      vendorData: clone(vendor),
      vendorContactPerson: clone(vendor.contactPersonArray || []),
    },
  });
};

export const updateVendor = async (id, payload) => {
  const vendors = loadVendors();
  const index = vendors.findIndex((v) => Number(v.vendor_id) === Number(id));

  if (index < 0) {
    return createResponse(
      {
        status: false,
        message: "Contact not found",
      },
      404
    );
  }

  const existing = vendors[index];
  vendors[index] = {
    ...existing,
    ...clone(payload),
    vendor_id: Number(id),
    country_name: payload.country_name || payload.country || existing.country_name || "",
    contactPersonArray: clone(payload.contactPersonArray || []),
    deleted: normalizeBool(existing.deleted),
    updatedAt: new Date().toISOString(),
    updatedBy_name: "Mock User",
  };

  saveVendors(vendors);

  return createResponse({
    status: true,
    message: "Contact updated successfully",
    data: { vendor_id: Number(id) },
  });
};

export const addVendor = async (payload) => {
  const vendors = loadVendors();
  const vendorId = nextId(vendors);
  const now = new Date().toISOString();

  const row = {
    ...clone(payload),
    vendor_id: vendorId,
    country_name: payload.country_name || payload.country || "",
    contactPersonArray: clone(payload.contactPersonArray || []),
    deleted: false,
    createdAt: now,
    updatedAt: now,
    createdBy_name: "Mock User",
    updatedBy_name: "Mock User",
  };

  vendors.unshift(row);
  saveVendors(vendors);

  return createResponse({
    status: true,
    message: "Contact saved successfully",
    data: { vendor_id: vendorId },
  });
};

export const deleteVendor = async (payload) => {
  const vendorId = Number(payload && payload.vendor_id);
  const vendors = loadVendors();
  const index = vendors.findIndex((v) => Number(v.vendor_id) === vendorId);

  if (index < 0) {
    return createResponse(
      {
        status: false,
        message: "Contact not found",
      },
      404
    );
  }

  vendors[index] = {
    ...vendors[index],
    deleted: true,
    updatedAt: new Date().toISOString(),
    updatedBy_name: "Mock User",
  };

  saveVendors(vendors);

  return createResponse({
    status: true,
    message: "Contact deleted successfully",
    data: { vendor_id: vendorId },
  });
};

export const getVendorLogs = async () =>
  createResponse({
    status: true,
    message: "Success",
    data: [],
  });
